import { createFeaturebaseSupportService } from './SupportService.featurebase';

export const mySupportService = createFeaturebaseSupportService();
